export default __webpack_public_path__ + "static/media/zfy59r9m.4a164fa1.jpg";